import { useResizeObserver } from '@vueuse/core'

export function useChartLogoPositions<T>(
  items: ComputedRef<T[]>,
  chartHeight: ComputedRef<number> | Ref<number>,
  chartRow: Ref<HTMLElement | null>,
  logoColumn: Ref<HTMLElement | null>,
) {
  const logoPositions = ref<number[]>([])

  const logoItems = computed(() => items.value.slice().reverse())

  function updateLogoPositions() {
    const chartRowEl = chartRow.value
    const logoColumnEl = logoColumn.value
    if (!chartRowEl || !logoColumnEl) {
      logoPositions.value = []
      return
    }

    const axisEl = chartRowEl.querySelector('[data-axis="y"]')
    if (!axisEl) {
      logoPositions.value = []
      return
    }

    const tickEls = Array.from(axisEl.querySelectorAll('g.tick'))
    const logoRect = logoColumnEl.getBoundingClientRect()

    const positions = tickEls
      .map((tickEl) => {
        const r = tickEl.getBoundingClientRect()
        return r.top + r.height / 2 - logoRect.top
      })
      .filter(y => Number.isFinite(y))
      .sort((a, b) => a - b)

    logoPositions.value = positions
  }

  watch([items, chartHeight], () => {
    nextTick(updateLogoPositions)
  }, { flush: 'post' })

  useResizeObserver(chartRow, updateLogoPositions)

  return { logoPositions, logoItems }
}
